import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ListService } from '../list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import Quill from 'quill';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit, AfterViewInit {
  item: any = '';
  question: any = '';
  quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [
          {
            size: [
              '10px',
              '12px',
              '14px',
              '16px',
              '18px',
              '24px',
              '32px',
              '48px',
            ],
          },
        ],
        [{ color: [] }, { background: [] }],
        ['link', 'image', 'video'],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
      ],
      handlers: {
        image: () => this.customImageHandler(),
      },
    },
  };
  htmlText: any = '';
  submitted: boolean = false;
  bolgs_cats: any;
  form: FormGroup;
  public image: any = null;
  public base_64_image: any;
  public faq_id = this.route.snapshot.paramMap.get('id');
  base_url = environment.baseUrl;
  @ViewChild('editor', { static: false }) editor: any;
  quillEditor: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private faq: ListService,
    private formbuilder: FormBuilder
  ) {}
  detectImage(event) {
    const file = event.target.files[0];
    this.image = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.base_64_image = reader.result;
    };
  }
  ngAfterViewInit() {
    this.quillEditor = this.editor?.quillEditor;
  }

  ngOnInit(): void {
    this.showAll();
    const list = JSON.parse(localStorage.getItem('blogs'));
    console.log(list);
    this.item = list.find((item: any) => item.id == this.faq_id);
    console.log(this.item);
    this.base_64_image = this.base_url + '/' + this.item.image;

    this.form = this.formbuilder.group({
      title: [this.item.title, Validators.required],
      summary: [this.item.summary, Validators.required],
      meta_title: [this.item.meta_title],
      category_id: [this.item.category_id, Validators.required],

      headlines: this.formbuilder.array([]),
    });

    this.item.headlines.forEach((headline: any) => {
      this.headlines.push(this.formbuilder.control(headline));
    });
    this.htmlText = this.item.content;
    const SizeStyle = Quill.import('attributors/style/size');
    SizeStyle.whitelist = [
      '10px',
      '12px',
      '14px',
      '16px',
      '18px',
      '24px',
      '32px',
      '48px',
    ];
    Quill.register(SizeStyle, true);
  }
  get headlines() {
    return this.form.get('headlines') as FormArray;
  }
  addHeadline() {
    this.headlines.push(this.formbuilder.control(''));
  }
  removeHeadline(i: number) {
    this.headlines.removeAt(i);
  }
  get f() {
    return this.form.controls;
  }
  showAll() {
    this.spinner.show();
    this.faq.list_cats().subscribe((data: any) => {
      console.log(data);

      this.bolgs_cats = data.data;

      console.log(data);
      this.spinner.hide();
    });
  }
  add() {
    this.submitted = true;
    if (this.form.invalid || this.htmlText == '' || this.htmlText == null) {
      return;
    }
    const form = {
      ...this.form.value,
      image: this.image,
      content: this.htmlText,
      blog_id: this.item.id,
    };
    console.log(form);
    this.spinner.show();
    this.faq.update(form).subscribe((response: any) => {
      console.log(response);
      this.spinner.hide();
      Swal.fire(`نجاح`, `تم تعديل المفال`, `success`);
      this.router.navigate(['/app/blogs/list']);
      // window.location.reload()
    });
  }
  customImageHandler() {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/webp'); // ✅ Only allow .webp
    input.click();

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return;

      // ✅ Check file type
      if (file.type !== 'image/webp') {
        alert('Only .webp images are allowed.');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result as string;
        const range = this.quillEditor?.getSelection(true);
        this.quillEditor?.insertEmbed(
          range?.index || 0,
          'image',
          base64,
          'user'
        );
      };
    };
  }
}
